// Auth helpers: session token lives in localStorage; sent as Authorization
// header on every API call via the axios interceptor in lib/api.js.
//
// Identity provider: WorkOS AuthKit (hosted UI at auth.workos.com).
// The backend builds the authorization URL — we don't hardcode it here.

import { api } from "@/lib/api";

const TOKEN_KEY = "spectraloom_session_token";

export function getSessionToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setSessionToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function clearSessionToken() {
  setSessionToken(null);
}

/**
 * Ask the backend for the WorkOS AuthKit authorization URL and redirect
 * the user to it. WorkOS will return them to /auth/callback?code=... which
 * <AuthCallback /> then exchanges for a persistent session_token via
 * POST /api/auth/callback.
 *
 * Pass the current origin's callback URL so the backend can honour it
 * (required when preview + production point to the same backend).
 */
export async function startLogin() {
  const redirectUri = window.location.origin + "/auth/callback";
  const r = await api.get("/auth/authorize-url", {
    params: { redirect_uri: redirectUri },
  });
  window.location.href = r.data.url;
}
